var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtrExclamationTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70151 1.375C7.27886 0.375001 8.72223 0.374999 9.29958 1.375L14.9287 11.125C15.068 11.3662 15.1317 11.622 15.1319 11.8713C15.1328 12.6555 14.5059 13.3752 13.6297 13.3752H2.37138C1.49516 13.3752 0.868278 12.6555 0.869142 11.8713C0.869376 11.6221 0.933055 11.3662 1.07234 11.125L6.70151 1.375ZM7.2182 10.4992C7.2182 10.085 7.55398 9.7492 7.9682 9.7492H7.97278C8.38699 9.7492 8.72278 10.085 8.72278 10.4992V10.5038C8.72278 10.918 8.38699 11.2538 7.97278 11.2538H7.9682C7.55398 11.2538 7.2182 10.918 7.2182 10.5038V10.4992ZM8.7182 5.44939C8.7182 5.03518 8.38241 4.69939 7.9682 4.69939C7.55398 4.69939 7.2182 5.03518 7.2182 5.44939V8.24939C7.2182 8.6636 7.55398 8.99939 7.9682 8.99939C8.38241 8.99939 8.7182 8.6636 8.7182 8.24939V5.44939Z",
    fill: "#B4371B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtrExclamationTriangle);
export default __webpack_public_path__ + "static/media/etr-exclamation-triangle.08f730cb5bb157d845cb6df0d2acd3ec.svg";
export { ForwardRef as ReactComponent };